export const Ellipsis = () => (
  <li className="w-8 select-none border-2 border-transparent py-2 text-center text-sm font-medium">
    ...
  </li>
);
